import React, {useState, Suspense} from 'react';
import { OrbitControls, softShadows, Environment } from '@react-three/drei'
import { Canvas } from '@react-three/fiber';
import Floor from './components/Floor'
import LiftConfiguratorPad from './components/LiftConfiguratorPad'
import defaultfloor from './components/config/defaultfloor.json'

softShadows();

export default function MainLift(props) {
  
  const [floorNum, setFloorNum] = useState(props.config.lift.floors.length);
  //const envcolor='#a3b1af'
  //const envcolor='#5c7a82'
  const envcolor='#1a2e42';
  
  
  const handleChangeFloorNum = num=>{
    setFloorNum(num);
    let newconfig = {};
    const oldnum = props.config.lift.floors.length;
    if( num<oldnum ){
      num = parseInt(num<2?2:num);
      newconfig = props.config;
      while( newconfig.lift.floors.length>num )
        newconfig.lift.floors = newconfig.lift.floors.slice(0,-1);
    }
    else
      if( num>oldnum ){
        num = parseInt(num>6?6:num);
        newconfig = props.config;
        while( newconfig.lift.floors.length<num )
        {
          newconfig.lift.floors.push( defaultfloor );
        }
      }
    
    props.updateConfig(newconfig);
  }

  const handleUpdateLiftSectionConfig = (section, config)=>{
    let newconfig = props.config;
    newconfig.lift[section] = config;
    props.updateConfig(newconfig);
  }

  let currentFloorBase = 0;
  const floors = props.config.lift.floors.map((floor,k)=>{
    currentFloorBase += k>0?props.config.lift.floors[k-1].height+props.config.lift.floors[k-1].ceil.height:0
    return(
      <Floor 
        key={`lift-floors-${k}`}
        dim={[props.config.lift.model.dimensions.width,props.config.lift.model.dimensions.depth,floor.height]}
        doors={floor.doors} 
        walls={floor.walls}
        ceil={floor.ceil}
        cabin={props.config.cabin}
        backwall={floor.backwall}
        structure={props.config.lift.structure}MainInfo
        position={[0, currentFloorBase, 0]}
      />
    )
  })

  return(
    <>
      <LiftConfiguratorPad 
          config={props.config.lift} 
          onChangeFloorNum={handleChangeFloorNum}
          updateSectionConfig={handleUpdateLiftSectionConfig}
          openFloorSection={props.openFloorSection}
      />

      <Canvas  
        camera={{ position: [650, 100, 230], far: 10000 }} 
        
        invalidateFrameloop
        //camera={{ fov: 115, position: [450, 100, 180], rotation: deg2rad(45)}}
        style={{height: '100%'}}
        shadowMap  
        colorManagement
      >
        <color attach="background" args={[envcolor]} />
        <OrbitControls target={[100, floorNum*100, 30]}/>
        <Suspense fallback={null}>
        <ambientLight intensity={0.4} 
          castShadow
        /> 
          <Environment
            background={false}
            preset={'apartment'}
          />

          <group position={[0,0,0]}>
            {floors}
          </group>

        </Suspense>
      </Canvas>

    </>
  )
}
